/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Payout method
 */
export type PayoutQuoteMethod = typeof PayoutQuoteMethod[keyof typeof PayoutQuoteMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutQuoteMethod = {
  UNIONPAY: 'UNIONPAY',
  BANK_SWIFT: 'BANK_SWIFT',
  ALIPAY: 'ALIPAY',
} as const;
